import { Alert, Grid, Tooltip, Typography } from "@mui/material";
import PreLoader from "../../../PreLoader";
import { CreditAudit } from "./types";
import { BodyContainer, Cell, Header, Row, Table } from 'wed-components-beta'
import { DateTime } from "luxon";
import { CSSProperties } from "react";

type CreditsAuditingDetailsProps = {
    data: CreditAudit | null;
    error: boolean;
    isLoading: boolean;
}

export const formatAssignmentName = (name: string, link: string | null, length: number) => {

    const assignment_name = name.slice(0, length) + '...'

    if (!link) return <Tooltip title="No link available">
        <p>{assignment_name}</p>
    </Tooltip>

    return <a href={link} target="_blank" style={{ color: '#fff' }} rel="noopener noreferrer">
        {assignment_name}
    </a>

}

export const formatAttemptTime = (time: number) => {
    const h = Math.floor(time / 3600)
    const m = Math.floor((time % 3600) / 60)
    const s = time % 60

    const pad = (num: number) => String(num).padStart(2, "0")

    return `${pad(h)}:${pad(m)}:${pad(s)}`
}

export const formatDate = (date: string) => {
    return DateTime.fromISO(date).toFormat("dd/MM/yy 'at' HH:mm")
}

export const formatCellStyle = (value: boolean) => {
    let style: CSSProperties = { color: '#666', textAlign: 'center' }

    if (value) {
        style.color = '#FA7C5F'
    }

    return style
}


export default function CreditsAuditingDetails({ data, error, isLoading }: CreditsAuditingDetailsProps) {
    console.log('data', data)
    if (isLoading || !data) return <PreLoader />

    if (error) return <Alert severity='error'>Error while loading.</Alert>

    const tableHeader = [
        { header: 'Assignment', width: 2.25 },
        { header: 'Submitted At', width: 1 },
        { header: 'Page Blur (max 2)', width: 1.25 },
        { header: 'Attempt Time (min)', width: 1.25 },
        { header: 'Score', width: .75 }
    ]

    return (
        <Grid container spacing={1}>
            <Grid item xs={11}>
                <Typography variant="h5">
                    {data.student_full_name}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                    {data.section_name}
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <Table>
                    <BodyContainer>
                        <Header>
                            {tableHeader.map((item, index) => (<Cell key={index} width={item.width}>{item.header}</Cell>))}
                        </Header>
                        {
                            data.submissions.length ?
                                data.submissions.map((item) => (
                                    <Row key={item.id}>
                                        <Cell width={tableHeader[0].width}>{formatAssignmentName(item.name, item.submissions_audit_statistics.assignment_link, 30)}</Cell>
                                        <Cell width={tableHeader[1].width}>{formatDate(item.submitted_at)}</Cell>
                                        <Cell width={tableHeader[2].width} style={formatCellStyle(item.submissions_audit_statistics.exceed_page_blur_limit)}>{item.submissions_audit_statistics.page_blurred}</Cell>
                                        <Cell width={tableHeader[3].width} style={formatCellStyle(item.submissions_audit_statistics.under_minimum_time_on_attempt)}>{formatAttemptTime(item.submissions_audit_statistics.time_on_attempt)}</Cell>
                                        <Cell width={tableHeader[4].width} style={formatCellStyle(item.submissions_audit_statistics.suspicious_score_fast_attempt)}>{item.submissions_audit_statistics.score}</Cell>
                                    </Row>
                                ))
                                :
                                <Row>
                                    <Cell flexGrow>Not found statistics for this student submissions, consider force-update audit logs on main page menu.</Cell>
                                </Row>
                        }
                    </BodyContainer>
                </Table>
            </Grid>

        </Grid>
    )
}
